export default __webpack_public_path__ + "static/media/back.a491cace.png";